import React from 'react';
import { Article, Clause, EmailLink, PageShell, SubOrderItem } from './shared';

export default function TermsPolicy() {
  const tocItems = [
    { href: '#s1', label: '제1조 목적' },
    { href: '#s2', label: '제2조 용어 정의' },
    { href: '#s3', label: '제3조 약관의 효력 및 변경' },
    { href: '#s4', label: '제4조 약관 외 준칙' },
    { href: '#s5', label: '제5조 이용계약의 성립' },
    { href: '#s6', label: '제6조 이용신청의 승낙 및 제한' },
    { href: '#s7', label: '제7조 회원정보의 변경' },
    { href: '#s8', label: '제8조 서비스의 이용' },
    { href: '#s9', label: '제9조 AI탐험여권 및 디지털 스탬프' },
    { href: '#s10', label: '제10조 서비스의 중단' },
    { href: '#s11', label: '제11조 회원 탈퇴 및 이용 변경·중지' },
    { href: '#s12', label: '제12조 정보 제공 및 광고' },
    { href: '#s13', label: '제13조 게시물에 대한 책임' },
    { href: '#s14', label: '제14조 콘텐츠 및 저작권' },
    { href: '#s15', label: '제15조 회사의 의무' },
    { href: '#s16', label: '제16조 회원의 의무' },
    { href: '#s17', label: '제17조 계정 관리 의무' },
    { href: '#s18', label: '제18조 회원 정보의 보호 및 이용' },
    { href: '#s19', label: '제19조 계약 해지 및 이용 제한' },
    { href: '#s20', label: '제20조 유료 서비스 이용' },
    { href: '#s21', label: '제21조 할인 쿠폰 및 혜택' },
    { href: '#s22', label: '제22조 손해배상' },
    { href: '#s23', label: '제23조 면책사항' },
    { href: '#s24', label: '제24조 회원에 대한 통지' },
    { href: '#s25', label: '제25조 분쟁 조정 및 관할법원' }
  ];

  return (
    <PageShell
      title="라이브클래스 서비스 이용약관"
      announcedAt="2026-04-08"
      effectiveAt="2026-05-08"
      tocItems={tocItems}
    >
      <Article id="s1" num="제1조" title="목적">
        <p className="text-sm text-slate-700 leading-relaxed">
          본 약관은 주식회사 네오랩(이하 "회사"라 합니다)이 운영하는
          라이브클래스 서비스(이하 "서비스"라 합니다)를 이용함에 있어 회사와
          이용자(이하 "회원"이라 합니다) 사이의 권리·의무, 서비스 이용 조건 및
          절차 등 필요한 사항을 규정함을 목적으로 합니다.
        </p>
      </Article>

      <Article id="s2" num="제2조" title="용어 정의">
        <p className="text-sm text-slate-700 leading-relaxed mb-4">
          본 약관에서 사용하는 주요 용어의 정의는 다음과 같습니다.
        </p>
        <Clause num="1.">
          "라이브클래스" 또는 "서비스": 회사가 PC, 태블릿, 스마트폰 등 유무선
          기기를 통해 제공하는 초등학생 대상 AI 라이브 교육
          플랫폼(liveclass.aiknow.ai.kr) 및 관련 앱·웹 서비스를 말합니다.
        </Clause>
        <Clause num="2.">
          "회원": 본 약관에 동의하고 계정을 생성하여 서비스를 이용하는
          자(학부모, 학생, 선생님 등)를 의미합니다.
        </Clause>
        <Clause num="3.">
          "선생님": 회사의 심사 절차를 통해 승인받고 서비스 내에서 수업을
          개설·진행하는 강사 회원을 의미합니다.
        </Clause>
        <Clause num="4.">
          "수강생": 서비스를 통해 수업을 수강하는 학생 회원을 의미합니다.
        </Clause>
        <Clause num="5.">
          "AI탐험여권": 수강생 각자에게 부여되는 디지털 학습 이력 기록 도구로,
          수업을 완료할 때마다 담당 선생님이 디지털 스탬프를 부여하여 학습
          성취를 시각적으로 확인할 수 있는 기능을 말합니다.
        </Clause>
        <Clause num="6.">
          "디지털 스탬프": 선생님이 수강생의 수업 완료를 확인하고 AI탐험여권에
          기록하는 전자 인증 마크를 의미합니다.
        </Clause>
        <Clause num="7.">
          "수업": 선생님과 회사가 공동으로 개설하거나, 회사가 기획·제공하는
          온라인 화상 기반 쌍방향 교육 콘텐츠를 말합니다.
        </Clause>
        <Clause num="8.">
          "게시물": 회원이 서비스 내에 등록·게시하는 텍스트, 이미지, 영상, 파일
          등 일체의 정보를 말합니다.
        </Clause>
      </Article>

      <Article id="s3" num="제3조" title="약관의 효력 및 변경">
        <Clause num="1.">
          본 약관은 서비스 내 화면 게시 또는 기타 방법으로 회원에게 공지함으로써
          효력이 발생합니다.
        </Clause>
        <Clause num="2.">
          회사는 관계법령에 위배되지 않는 범위에서 본 약관을 개정할 수 있습니다.
        </Clause>
        <Clause num="3.">
          회사는 약관을 개정하는 경우 개정 사유 및 시행일을 명시하여 시행일 7일
          전부터 공지합니다. 단, 회원의 권리·의무에 중대한 영향을 미치는 변경의
          경우 최소 30일 전에 공지하고 등록된 이메일로 개별 통지합니다.
        </Clause>
        <Clause num="4.">
          공지 이후 회원이 명시적으로 거부 의사를 표시하지 않는 경우 개정약관에
          동의한 것으로 봅니다.
        </Clause>
        <Clause num="5.">
          변경된 약관에 동의하지 않는 회원은 서비스 이용계약을 해지할 수
          있습니다.
        </Clause>
      </Article>

      <Article id="s4" num="제4조" title="약관 외 준칙">
        <Clause num="1.">
          본 약관에 명시되지 않은 사항은 정보통신망 이용촉진 및 정보보호 등에
          관한 법률, 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에
          관한 법률 등 관련 법령에 따릅니다.
        </Clause>
        <Clause num="2.">
          회사는 서비스 내 개별 기능(AI탐험여권 등)에 대해 별도의 운영 정책을
          정할 수 있으며, 이 경우 개별 정책이 본 약관보다 우선합니다.
        </Clause>
      </Article>

      <Article id="s5" num="제5조" title="이용계약의 성립">
        <Clause num="1.">
          서비스 이용계약은 가입 신청자가 회사가 정한 양식에 따라 정보를
          입력하고 본 약관 및 개인정보처리방침에 동의한 후 회사가 이를
          승낙함으로써 성립합니다.
        </Clause>
        <Clause num="2.">
          만 14세 미만 아동의 경우 법정대리인(보호자)이 계정을 생성하며, 생성된
          계정은 보호자와 자녀가 함께 사용할 수 있습니다. 보호자는 자녀의 수업
          참여 현황, AI탐험여권 스탬프 기록 등을 동일 계정에서 확인하고 관리할
          수 있습니다. 만 14세 미만 자녀의 개인정보는 라이브클래스 수업 운영
          목적으로만 활용되며, 수집 항목은 서비스 제공에 필요한 최소한으로
          제한합니다.
        </Clause>
      </Article>

      <Article id="s6" num="제6조" title="이용신청의 승낙 및 제한">
        <Clause num="1.">
          회사는 이용 신청에 대하여 업무상·기술상 지장이 없는 한 접수 순서에
          따라 승낙합니다.
        </Clause>
        <Clause num="2.">
          다음 각 호에 해당하는 경우 회사는 이용 신청을 승낙하지 않거나 사후에
          이용계약을 해지할 수 있습니다.
          <div className="mt-2">
            <SubOrderItem num="(1)">
              타인의 정보를 도용하거나 허위 정보를 기재한 경우
            </SubOrderItem>
            <SubOrderItem num="(2)">
              서비스의 안녕·질서를 해치거나 해칠 목적으로 신청한 경우
            </SubOrderItem>
            <SubOrderItem num="(3)">
              기술적 사유로 서비스 제공이 불가능한 경우
            </SubOrderItem>
            <SubOrderItem num="(4)">
              회원 자격을 상실한 이력이 있는 자가 재신청한 경우(단, 회사의
              재가입 승낙을 받은 경우 예외)
            </SubOrderItem>
            <SubOrderItem num="(5) ">
              기타 회사가 정한 운영 기준에 부합하지 않는 경우
            </SubOrderItem>
          </div>
        </Clause>
      </Article>

      <Article id="s7" num="제7조" title="회원정보의 변경">
        <Clause num="1.">
          회원은 서비스 내 설정 화면에서 언제든지 자신의 정보를 열람·수정할 수
          있습니다.
        </Clause>
        <Clause num="2.">
          회원정보가 변경된 경우 즉시 수정하여야 하며, 미수정으로 인한 불이익은
          회원이 부담합니다.
        </Clause>
      </Article>

      <Article id="s8" num="제8조" title="서비스의 이용">
        <Clause num="1.">
          서비스는 회원의 가입 승낙 후 즉시 이용 가능합니다.
        </Clause>
        <Clause num="2.">
          서비스는 연중무휴 24시간 이용을 원칙으로 합니다. 다만, 회사의
          기술상·운영상 이유로 일시 중단될 수 있으며 이 경우 사전 또는 사후에
          공지합니다.
        </Clause>
        <Clause num="3.">
          수업은 회사가 지정한 온라인 화상 플랫폼을 통해 제공되며, 수업 일정은
          서비스 내 공지를 통해 확인할 수 있습니다.
        </Clause>
      </Article>

      <Article
        id="s9"
        num="제9조"
        title="AI탐험여권 및 디지털 스탬프"
        headerBlue={true}
      >
        <Clause num="1.">
          회사는 수강생 각자에게 AI탐험여권을 제공하며, 이는 수강생의 학습
          이력과 성취를 기록하는 개인별 디지털 학습 기록부입니다.
        </Clause>
        <Clause num="2.">
          수강생이 수업을 완료하면 담당 선생님은 해당 수강생의 AI탐험여권에
          디지털 스탬프를 부여합니다. 디지털 스탬프는 수업 완료의 공식 확인
          수단이며, 선생님의 재량과 판단에 따라 부여됩니다.
        </Clause>
        <Clause num="3.">
          AI탐험여권에 누적된 디지털 스탬프는 수강생의 학습 동기 부여를 위한
          목적으로 활용되며, 회사는 일정 기준 이상의 스탬프를 획득한 수강생에게
          별도의 보상 또는 혜택을 제공할 수 있습니다.
        </Clause>
        <Clause num="4.">
          AI탐험여권 및 디지털 스탬프 기록은 수강생 계정에 귀속되며, 계정 탈퇴
          시 관련 기록은 회사의 개인정보처리방침에 따라 처리됩니다.
        </Clause>
        <Clause num="5.">
          디지털 스탬프 기록은 임의로 위·변조할 수 없으며, 이를 시도하는 경우
          회사는 해당 회원에 대한 서비스 이용을 제한하거나 계약을 해지할 수
          있습니다.
        </Clause>
        <Clause num="6.">
          AI탐험여권의 운영 방식, 스탬프 부여 기준 및 관련 혜택은 서비스 운영
          정책에 따라 변경될 수 있으며, 변경 시 사전에 공지합니다.
        </Clause>
      </Article>

      <Article id="s10" num="제10조" title="서비스의 중단">
        <Clause num="1.">
          회사는 정보통신설비의 보수·점검, 통신 장애, 천재지변 등 불가항력적
          사유 발생 시 서비스를 일시 중단할 수 있습니다.
        </Clause>
        <Clause num="2.">
          예정된 서비스 중단은 최소 7일 전에 공지하며, 불가피한 경우 사후 공지할
          수 있습니다.
        </Clause>
        <Clause num="3.">
          서비스 중단으로 인해 예정된 수업이 진행되지 못한 경우, 회사는 대체
          수업 일정 제공 또는 환불 등 적절한 조치를 취합니다.
        </Clause>
      </Article>

      <Article id="s11" num="제11조" title="개인정보 보호책임자">
        <Clause num="1.">
          회원은 언제든지 서비스 내 또는 고객센터를 통해 탈퇴를 요청할 수
          있으며, 회사는 즉시 이를 처리합니다.
        </Clause>
        <Clause num="2.">
          탈퇴 시 수강생의 AI탐험여권 내 디지털 스탬프 기록을 포함한 학습 이력,
          보유 쿠폰, 미사용 포인트 등은 모두 소멸되며 복구되지 않습니다.
        </Clause>
        <Clause num="3.">
          다음 각 호에 해당하는 경우 회사는 사전 통보 없이 회원의 서비스 이용을
          제한하거나 계약을 해지할 수 있습니다.
          <div className="mt-2">
            <SubOrderItem num="(1)">
              관계법령 또는 본 약관을 위반한 경우
            </SubOrderItem>
            <SubOrderItem num="(2)">
              타인의 개인정보나 결제수단을 도용한 경우
            </SubOrderItem>
            <SubOrderItem num="(3)">
              AI탐험여권 또는 디지털 스탬프를 위·변조하거나 부정한 방법으로
              취득하려 한 경우
            </SubOrderItem>
            <SubOrderItem num="(4)">
              서비스의 정상적인 운영을 방해하거나 다른 회원에게 피해를 입힌 경우
            </SubOrderItem>
            <SubOrderItem num="(5) ">
              회사의 동의 없이 영리를 목적으로 서비스를 이용한 경우
            </SubOrderItem>
          </div>
        </Clause>
        <Clause num="4.">
          탈퇴 후 7일 이내 재가입은 불가하며, 기존 이용 이력은 복구되지
          않습니다.
        </Clause>
      </Article>

      <Article id="s12" num="제12조" title="정보 제공 및 광고">
        <Clause num="1.">
          회사는 서비스 운영을 위해 이메일, SMS, 앱 푸시 등을 통해 회원에게
          정보를 제공할 수 있습니다.
        </Clause>
        <Clause num="2.">
          회사는 회원의 사전 동의를 받아 광고성 정보를 제공할 수 있으며, 수신
          거부 의사를 표시한 회원에게는 영리 목적의 광고를 발송하지 않습니다.
        </Clause>
        <Clause num="3.">
          다음 각 호의 경우 회원 동의 여부와 무관하게 이메일 등을 발송할 수
          있습니다.
          <div className="mt-2">
            <SubOrderItem num="(1)">
              본인 인증 또는 정보 변경 확인을 위한 인증 메일 발송
            </SubOrderItem>
            <SubOrderItem num="(2)">
              수업 일정, AI탐험여권 스탬프 부여 알림 등 서비스 이용에 필수적인
              정보 제공
            </SubOrderItem>
            <SubOrderItem num="(3)">
              약관 변경 등 회원이 반드시 알아야 하는 중대한 사항 공지
            </SubOrderItem>
          </div>
        </Clause>
      </Article>

      <Article id="s13" num="제13조" title="게시물에 대한 책임">
        <Clause num="1.">
          회원이 게시한 게시물의 법적 책임은 해당 회원에게 있으며, 게시물이
          타인의 권리를 침해하지 않도록 주의하여야 합니다.
        </Clause>
        <Clause num="2.">
          다음 각 호에 해당하는 게시물은 사전 통지 없이 삭제할 수 있습니다.
          <div className="mt-2">
            <SubOrderItem num="(1)">
              타인의 명예를 훼손하거나 사생활을 침해하는 내용
            </SubOrderItem>
            <SubOrderItem num="(2)">
              아동·청소년에게 유해한 내용 또는 폭력·음란물
            </SubOrderItem>
            <SubOrderItem num="(3)">
              저작권 등 타인의 지식재산권을 침해하는 내용
            </SubOrderItem>
            <SubOrderItem num="(4)">
              허가받지 않은 광고·홍보 목적의 게시물
            </SubOrderItem>
            <SubOrderItem num="(5)">
              관계법령 또는 본 약관에 위반되는 내용
            </SubOrderItem>
          </div>
        </Clause>
      </Article>

      <Article id="s14" num="제14조" title="콘텐츠 및 저작권">
        <Clause num="1.">
          회사가 제작한 수업 콘텐츠, AI탐험여권 디자인 및 서비스 내 저작물에
          대한 저작권은 회사에 귀속됩니다.
        </Clause>
        <Clause num="2.">
          회원이 서비스에 게시한 게시물의 저작권은 게시한 회원에게 귀속됩니다.
          다만, 회원은 서비스 운영·개선 및 홍보 목적으로 회사가 게시물을
          사용하는 것에 동의합니다.
        </Clause>
        <Clause num="3.">
          회원은 서비스를 통해 제공되는 수업 콘텐츠를 무단으로 복제, 배포, 편집,
          공중송신하거나 상업적으로 이용할 수 없습니다.
        </Clause>
      </Article>

      <Article id="s15" num="제15조" title="회사의 의무">
        <Clause num="1.">
          회사는 회원의 개인정보를 본인 동의 없이 제3자에게 제공하지 않으며,
          개인정보처리방침에 따라 안전하게 관리합니다.
        </Clause>
        <Clause num="2.">
          회사는 서비스와 관련한 회원의 불만사항을 신속하게 처리하며, 처리가
          지연될 경우 사유와 일정을 회원에게 통지합니다.
        </Clause>
        <Clause num="3.">
          회사는 AI탐험여권 시스템의 안정적 운영을 위해 최선을 다하며, 기술적
          오류로 인한 스탬프 누락이 확인되는 경우 복구 조치를 취합니다.
        </Clause>
        <Clause num="3.">
          회사의 고의 또는 중과실로 인해 회원에게 손해가 발생한 경우 통상 손해의
          범위 내에서 배상합니다.
        </Clause>
      </Article>

      <Article id="s16" num="제16조" title="회원의 의무">
        <Clause num="1.">
          서비스는 회원의 가입 승낙 후 즉시 이용 가능합니다.
          <div className="mt-2">
            <SubOrderItem num="(1)">
              허위 정보 등록 또는 타인 정보 도용
            </SubOrderItem>
            <SubOrderItem num="(2)">
              AI탐험여권 또는 디지털 스탬프의 위·변조, 부정 취득 시도
            </SubOrderItem>
            <SubOrderItem num="(2)">
              서비스의 정상적인 운영을 방해하는 행위 또는 시스템 해킹
            </SubOrderItem>
            <SubOrderItem num="(2)">
              회사·타인의 저작권 등 지식재산권 침해 행위
            </SubOrderItem>
            <SubOrderItem num="(2)">
              외설·폭력적 게시물 등 공서양속에 반하는 내용 게시
            </SubOrderItem>
            <SubOrderItem num="(2)">
              회사의 사전 동의 없이 영리 목적으로 서비스를 이용하거나 제3자에게
              수업 영상·콘텐츠를 배포하는 행위
            </SubOrderItem>
            <SubOrderItem num="(2)">
              기타 법령 또는 회사 운영 정책에 위반되는 일체의 행위
            </SubOrderItem>
          </div>
        </Clause>
        <Clause num="2.">
          회원은 본인의 계정 이용 권한을 타인에게 양도하거나 담보로 제공할 수
          없습니다.
        </Clause>
      </Article>

      <Article id="s17" num="제17조" title="계정 관리 의무">
        <Clause num="1.">
          회원은 자신의 계정 및 비밀번호를 제3자에게 제공하거나 공유해서는 안
          됩니다.
        </Clause>
        <Clause num="2.">
          계정 도용이나 무단 사용을 인지한 경우 즉시 회사에 통보하고 안내에
          따라야 합니다. 미통보로 인한 불이익은 회원이 부담합니다.
        </Clause>
        <Clause num="3.">
          보호자가 생성한 계정은 보호자와 자녀가 공동으로 사용할 수 있으며,
          보호자는 계정을 통해 자녀의 수업 이력 및 학습 활동을 함께 확인할 수
          있습니다. 만 14세 미만 자녀의 개인정보는 수업 운영 및 학습 지원 목적
          외에는 사용하지 않으며, 불필요한 정보는 수집하지 않습니다.
        </Clause>
      </Article>

      <Article id="s18" num="제18조" title="회원 정보의 보호 및 이용">
        <Clause num="1.">
          회사는 서비스 제공에 필요한 최소한의 개인정보를 적법하게
          수집·이용합니다.
        </Clause>
        <Clause num="2.">
          AI탐험여권 내 학습 이력(수강 이력, 디지털 스탬프 기록 등)은 서비스
          품질 개선 및 학습 분석 목적으로 활용될 수 있으며, 수강생 식별 정보와
          분리하여 분석합니다.
        </Clause>
        <Clause num="3.">
          회사는 관계법령에 따라 수사기관 등 행정기관이 회원 정보 제출을
          요청하는 경우 이에 응할 수 있습니다.
        </Clause>
        <Clause num="4.">
          개인정보 처리에 관한 상세 사항은 회사의 개인정보처리방침을 따릅니다.
        </Clause>
      </Article>

      <Article id="s19" num="제19조" title="계약 해지 및 이용 제한">
        <Clause num="1.">
          회원은 서비스 내 설정 또는 고객센터(
          <EmailLink email="gotoaiknow@gmail.com" />
          )를 통해 이용계약을 해지할 수 있습니다.
        </Clause>
        <Clause num="2.">
          회사는 회원이 본 약관을 위반하거나 서비스 운영을 방해하는 경우 경고,
          일시 이용정지, 영구 이용정지 등 단계적으로 제한 조치를 취할 수
          있습니다.
        </Clause>
        <Clause num="3.">
          이용 제한 조치에 이의가 있는 경우 회원은 고객센터를 통해 이의를 신청할
          수 있으며, 회사는 이의 신청이 정당하다고 판단되는 경우 즉시 이용을
          재개합니다.
        </Clause>
        <Clause num="4.">
          3개월 이상 서비스에 로그인하지 않은 경우 회사는 개인정보 보호 및 운영
          효율성을 위해 이용을 제한할 수 있습니다.
        </Clause>
      </Article>

      <Article id="s20" num="제20조" title="유료 서비스 이용">
        <Clause num="1.">
          라이브클래스의 유료 수업에 대한 모든 결제는 회사가 직접 처리하지
          않으며, 결제 대행 서비스인 이벤터스(
          <a
            href="https://event-us.kr/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            https://event-us.kr
          </a>
          )를 통해서만 진행됩니다.
        </Clause>
        <Clause num="2.">
          수업 신청 및 결제, 취소, 환불 등 결제와 관련된 모든 사항은 이벤터스의
          정책 및 절차에 따르며, 회원은 이벤터스 이용약관을 별도로 확인하고
          동의하여야 합니다.
        </Clause>
        <Clause num="3.">
          결제 과정에서 발생하는 오류, 분쟁, 개인정보 처리 등에 대한 책임은
          이벤터스에 있으며, 회사는 이벤터스의 결제 처리 과정에서 발생한 문제에
          대해 책임을 지지 않습니다.
        </Clause>
        <Clause num="4.">
          회원은 결제 전 이벤터스 사이트에서 수업별 결제 금액, 환불 조건 등을
          반드시 확인하여야 합니다.
        </Clause>
      </Article>

      <Article id="s21" num="제21조" title="할인 쿠폰 및 혜택">
        <Clause num="1.">
          회사는 프로모션, AI탐험여권 스탬프 달성 보상 등의 목적으로 할인 쿠폰
          또는 혜택을 제공할 수 있으며, 세부 내용(종류, 할인율, 사용 기한, 사용
          조건 등)은 서비스 화면에 표시됩니다.
        </Clause>
        <Clause num="2.">
          할인 쿠폰은 현금으로 환급되지 않으며, 사용 기간 만료 또는 회원 자격
          종료 시 자동 소멸됩니다.
        </Clause>
        <Clause num="3.">
          쿠폰을 부정한 방법으로 취득하거나 사용하는 경우 회사는 해당 쿠폰을
          회수하고 회원 자격을 제한할 수 있습니다.
        </Clause>
        <Clause num="4.">
          회원 탈퇴 시 사용되지 않은 쿠폰 및 스탬프 보상 혜택은 즉시 소멸되며
          복구되지 않습니다.
        </Clause>
      </Article>

      <Article id="s22" num="제22조" title="손해배상">
        <Clause num="1.">
          회원이 본 약관을 위반하여 회사에 손해를 가한 경우, 해당 회원은 발생한
          모든 손해를 배상하여야 합니다.
        </Clause>
        <Clause num="2.">
          회원의 불법·위반 행위로 인해 회사가 제3자로부터 클레임을 받는 경우,
          해당 회원은 자신의 비용으로 회사를 면책하여야 하며, 면책되지 못한
          손해를 배상하여야 합니다.
        </Clause>
      </Article>

      <Article id="s23" num="제23조" title="면책사항">
        <Clause num="1.">
          회사는 선생님과 수강생 사이에서 발생하는 분쟁·손해에 대해 회사의
          고의·과실이 없는 한 책임을 지지 않습니다.
        </Clause>
        <Clause num="2.">
          회사는 서비스를 통해 제공되는 콘텐츠의 정확성·완전성을 보증하지
          않으며, 그 내용에 대한 최종적인 판단과 책임은 이용자에게 있습니다.
        </Clause>
        <Clause num="3.">
          회사는 서비스와 연결된 제3자 플랫폼의 콘텐츠·운영에 대해 책임을 지지
          않으며, 제3자 플랫폼 이용은 회원 본인의 판단과 책임 하에 이루어집니다.
        </Clause>
        <Clause num="4.">
          AI탐험여권의 디지털 스탬프 기록은 수강 완료를 확인하는 학습 동기 부여
          수단으로, 특정 자격이나 학력을 증명하는 공식 문서가 아닙니다. 이와
          관련하여 회사는 별도의 법적 보증을 하지 않습니다.
        </Clause>
        <Clause num="5.">
          회원의 귀책 사유로 인한 서비스 이용 장애, 개인정보 노출 등에 대하여
          회사는 책임을 지지 않습니다.
        </Clause>
        <Clause num="6.">
          회사는 천재지변, 전쟁, 해킹 등 회사의 통제 범위를 벗어난 사유로 발생한
          손해에 대해 책임을 지지 않습니다.
        </Clause>
      </Article>

      <Article id="s24" num="제24조" title="회원에 대한 통지">
        <Clause num="1.">
          회사는 개별 회원에 대한 통지를 등록된 이메일, SMS, 앱 푸시 등의
          방법으로 할 수 있습니다.
        </Clause>
        <Clause num="2.">
          불특정 다수 회원에 대한 통지는 서비스 공지사항 게시로 개별 통지에
          갈음할 수 있습니다.
        </Clause>
      </Article>

      <Article id="s25" num="제25조" title="분쟁 조정 및 관할법원">
        <Clause num="1.">
          서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우, 양
          당사자는 성실히 협의하여 해결합니다.
        </Clause>
        <Clause num="2.">
          협의로 해결되지 않는 경우, 회사의 본사 소재지를 관할하는 법원을 전속
          관할법원으로 합니다.
        </Clause>
        <Clause num="3.">
          본 약관 및 서비스 이용과 관련된 소송에는 대한민국 법률이 적용됩니다.
        </Clause>
        <Clause num="4.">
          본 약관은 한국어로 작성되었으며, 번역본이 있는 경우 한국어 원문이
          우선합니다.
        </Clause>
      </Article>

      <div className="bg-blue-50 border border-blue-200 rounded-xl px-7 py-5 mb-5">
        <h2 className="text-[15px] font-bold text-blue-900 mb-2">부칙</h2>
        <p className="text-[14px] text-slate-700">
          본 개인정보처리방침은 2026년 05월 08일부터 시행됩니다.
        </p>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl px-7 py-6">
        <h3 className="text-[15px] font-bold text-slate-800 mb-4 pb-3 border-b border-slate-100">
          개인정보보호 담당
        </h3>
        <dl className="grid grid-cols-[auto_1fr] gap-x-8 gap-y-2.5 text-sm">
          {[
            { key: '담당', val: '조주현' },
            { key: '연락처', val: <EmailLink email="gotoaiknow@gmail.com" /> },
            {
              key: '서비스',
              val: (
                <a
                  href="https://liveclass.aiknow.ai.kr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  https://liveclass.aiknow.ai.kr
                </a>
              )
            }
          ].map(({ key, val }) => (
            <React.Fragment key={key}>
              <dt className="text-slate-400 font-medium">{key}</dt>
              <dd className="text-slate-700">{val}</dd>
            </React.Fragment>
          ))}
        </dl>
      </div>
    </PageShell>
  );
}
